<template>
	<div>
		<order-item
			v-for="(line, index) in filteredOrderLines"
			:key="getOrderItemKey(index, line)"
			:productSelection="getSelection(line)"
			:orderLine="line"
			:receiptLine="receiptLines[index]"
			:cartProducts="cartProducts"
			:virtualId="line.virtualId"
			:product="getProducts(line)[0]"
			:isProductConfiguring="isProductConfiguring"
			:globalSelectedShop="globalSelectedShop"
			:productCatalog="productCatalog"
			:tenantSettings="tenantSettings"
		>
		</order-item>
		<div v-if="globalDiscounts.length > 0 && !discountLoading" class="order-discount-card">
			<order-discount
				v-for="globalDiscount in globalDiscounts"
				:key="globalDiscount.type"
				:productSelection="null"
				:orderLine="globalDiscount.orderLine"
				:receiptLine="globalDiscount.receiptLine"
				:cartProducts="cartProducts"
				:discountLoading="discountLoading"
				:isProductConfiguring="isProductConfiguring"
				:productCatalog="productCatalog"
			>
			</order-discount>
		</div>
		<order-delivery
			v-if="deliveryOption"
			:receiptLine="deliveryOption.receiptLine"
		/>
		<popular-side-orders :orderLines="filteredOrderLines" :receiptLines="receiptLines"/>
	</div>

</template>

<script>
	import appConfig from "../../../../appconfig";
	import ProductSelection from "../../../../domains2/orders/ProductSelection";
	import OrderItem from "./OrderItem-gt3";
	import OrderDiscount from "./OrderDiscount-gt3";
	import OrderDelivery from "../../gt2/ShoppingCart/OrderDelivery";
	import OrderHelperObject from "../../../../domains2/orders/OrderHelperObject";
	import OrderPresentationMixin from "../../../../mixins/OrderPresentation.mixin";
	import {evaluateCustomerType, remapGTMReceiptLines} from "../../../../libraries/utils";
	import PopularSideOrders from "../../gt2/ShoppingCart/PopularSideOrders.vue";
	import * as mutationTypes from "../../../../store/mutation-types";
	import { mapGetters } from "vuex";
	import {convertProductSelectionsToMap} from "../../../../helper/ProductSelectionHelper";

	export default {
		name: "OrderPresentation-gt3",
		props: [
			"cartProducts", "isProductConfiguring", "discountLoading", "cartOrderTags", "productCatalog",
			"vouchersRedeemed", "globalSelectedShop", "tenantSettings"
		],
		components: {
			PopularSideOrders,
			OrderDelivery,
			OrderItem,
			OrderDiscount
		},
		data() {
			return {
				cartQuantityDialogShown: false,
				timeoutHandle: null
			};
		},
		mounted() {
			localStorage.removeItem("gtmReceiptLines");
			localStorage.setItem("gtmReceiptLines", remapGTMReceiptLines(this.receiptLines, this.orderLines));
			if(this.$store.getters.isReorderState && !this.discountLoading) {
				this.$store.commit(mutationTypes.SET_PREVIOUS_ORDER_TOTAL, this.$store.getters.totalPrice);
			}
		},
		watch: {
			receiptLines() {
				localStorage.removeItem("gtmReceiptLines");
				localStorage.setItem("gtmReceiptLines", remapGTMReceiptLines(this.receiptLines, this.orderLines));
			}
		},
		mixins: [OrderPresentationMixin],
		methods: {
			getOrderItemKey: OrderHelperObject.getOrderItemKey
		},
		computed: {
			...mapGetters(["featureToggles"]),
			orderLines() {
				return ProductSelection.mapToOrderLinesGx(appConfig.getBusinessModelId())(
					this.productCatalog,
					this.cartProducts,
					false,
					{
						vouchers: this.vouchersRedeemed,
						employeeDiscountToken: this.$store.getters.employeeDiscountToken,
						sunsetPoints: this.$store.getters.sunsetPoints,
						dailySpending: this.$store.getters.featureToggles.discountDailyLimit
							? this.$store.getters.applicationUserData && this.$store.getters.applicationUserData.meta.dailySpending
							: {},
						channel: appConfig.channelAlias(),
						deliveryMethod: this.$store.getters.tenantSpecificData.deliveryChoice,
						customerType: evaluateCustomerType(),
						cartProductsMap: convertProductSelectionsToMap(this.cartProducts),
						enableProductBestPriceInCatalogAndCart: this.featureToggles.enableProductBestPriceInCatalogAndCart
					},
					this.cartOrderTags
				)
					.filter(ol => ol.type !== "Meta");
			},
			receiptLines() {
				const self = this;
				return OrderHelperObject.mapToReceiptLines(self.orderLines, self.$i18n);
			},
			deliveryOption() {
				const orderLine = (this.orderLines || []).find((e) => e.type === "Delivery");
				const receiptLine = (this.receiptLines || []).find((e) => e.type === "Delivery");
				if (!orderLine || !receiptLine) {
					return null;
				}
				return {
					receiptLine,
					orderLine
				};
			},
			editableOnCheckout() {
				const self = this;
				return self.product.options.editableOnCheckout !== false;
			}
		}
	};
</script>

<style scoped lang="scss">
	.basket-product-height {
		min-height: 140px;
	}

	.basket-layout {
		display: inline-grid;

		.product-title {
			font-size: 22px;
			padding-bottom: 10px;
			line-height: 1;
		}

		.product-description {
			line-height: 1.4;
			padding-bottom: 20px;
			font-size: 17px;
		}
	}

	.amount-btn-edit {
		position: absolute;
		right: 10px;

		.add-btn-selected-color {
			background-color: #ffc627 !important;
			color: #231f20 !important;
			font-size: 30px;
			border: 1px solid #ffc627;
			height: 44px;
			width: 44px;
			min-width: 44px;
			border-radius: 4px;
			will-change: box-shadow;
			box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
		}

		.edit-button-cr {
			background-color: white !important;
			height: 44px;
			width: 44px;
			min-width: 44px;
			border-radius: 4px;
		}

		.total-price, .discounted-total-price {
			font-size: 15px;
		}

		.discounted-total-price {
			.menu-price, .old-menu-price {
				display: inline;
			}
		}

		.edit-button-cr .v-icon {
			font-size: 32px;
		}

		.add-remove-btn {
			position: relative;
			text-align: center;
			background-color: #fff;
			-webkit-border-radius: 6px;
			-moz-border-radius: 6px;
			border-radius: 6px;
			box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
			padding: 4px;

			.v-btn {
				height: 44px;
				width: 44px;
				min-width: 44px;
				-webkit-border-radius: 4px;
				-moz-border-radius: 4px;
				border-radius: 4px;
				margin: 0;

				.v-btn__content {
					padding: 0 12px;
				}

				.v-icon {
					font-weight: bold;
				}
			}

			.v-chip {
				background-color: #ffffff;
				font-weight: bold;
				font-size: 30px;
				min-width: 60px;
				text-align: center;
				color: #231f20;
				margin: 4px 16px;

				/deep/ .v-chip__content {
					margin: 0 auto;
				}
			}

			.v-btn:last-child {
				background-color: #ffc627 !important;
				color: #231f20;
			}

			.v-btn:first-child {
				background-color: #d8d8d8 !important;
				color: #231f20;
			}
		}
	}

	@media(max-width: 420px) {
		.product-description {
			font-size: 15px !important;
		}
	}

	.theme--light .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
		background-color: #ffc627 !important;
		color: #231f20 !important;
		font-size: 30px;
		border: 1px solid #ffc627;
		height: 44px;
		width: 44px;
		min-width: 44px;
		border-radius: 4px;
		will-change: box-shadow;
		box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
	}

	.bullet-basket-product {
		font-size: 8px;
		color: #23282A;
		padding-bottom: 4px;
		padding-right: 2px;
	}

	.lowercase-menu {
		text-transform: lowercase;
	}

	.remove-ease-button {
		margin-left: 0 !important;
		color: #63666a;
		text-decoration: underline;
		width: 35px !important;
		min-width: 35px !important;
		height: 25px !important;
		text-transform: capitalize;
		font-size: 16px;
	}
	.product-description{
		display: flex;
		font-family: Dispatch;
		font-size: 13px !important;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.46;
		letter-spacing: normal;
		color: #222222;
		margin-top: 4px;
		margin-bottom: 29px;
		.unit-price{
			font-family: Dispatch;
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.36;
			letter-spacing: normal;
			color: #000000;
			padding-top: 16px;
		}
	}
</style>
